import { Autocomplete, type AutocompleteProps, TextField, type TextFieldProps } from "@mui/material";
import type { TFormSmsTemplate } from "./types";

export interface IFormSmsInputTempaltesProps<Template extends TFormSmsTemplate>
  extends Omit<
    AutocompleteProps<Template, false, false, false, "div">,
    "renderInput" | "getOptionLabel" | "getOptionKey" | "slotProps"
  > {
  label?: string;
  slotProps?: AutocompleteProps<Template, false, false, false, "div">["slotProps"] & {
    textField?: Partial<TextFieldProps>;
  };
}

export const FormSmsInputTemplates = <Template extends TFormSmsTemplate>({
  label = "Modèle",
  slotProps,
  ...props
}: IFormSmsInputTempaltesProps<Template>) => {
  return (
    <Autocomplete
      size="small"
      fullWidth
      slotProps={slotProps}
      {...props}
      renderInput={(params) => <TextField {...params} {...slotProps?.textField} label={label} />}
      getOptionLabel={(template) => template.name}
      getOptionKey={(template) => template._id}
    />
  );
};
